// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__bq9V7","icon":"button_icon__qPf90","starsIcon":"button_starsIcon__Cu18n"};